import React, { useEffect, useState, useCallback } from "react";
import { capitalize, debounce } from "lodash";
import { Box, Button, Card, CardContent, CardHeader, IconButton, Input, InputAdornment, Tooltip, Dialog, DialogActions, DialogTitle, FormGroup, FormControlLabel, Switch } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { userServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import TableFilter from "../../components/shared/TableFilter";
import { STATUS_OPTIONS_LIST, TRANGATIONTYPE_TYPE, Verification_OPTIONS } from "../../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import { EditOutlined } from "@mui/icons-material";
import { Loader } from "../../components/CustomLoader";
import { fDate } from "../../utils/formatTime";
import { TrimText } from "../../utils/helpers";
import ViewTransactionDetail from "./ViewTransactionDetail";

export default function AllTrangectionList() {
    const navigate = useNavigate();
    const [searchItem, setSearchItem] = useState("");
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [status, setStatus] = useState([]);
    const [show, setShow] = useState(false);
    const [warning, setWarning] = useState("");
    const [currentStatus, setCurrentStatus] = useState(null);
    const [statusId, setStatusId] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [viewId, setViewId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loaderDelay, setLoaderDelay] = useState(false);
    const [type, setType] = useState([]);
    const { id } = useParams();

    const fetchUsers = async (query) => {
        if (id) {
            const body = {
                searchItem: query || "",
                pageNumber: currentPage,
                pageSize: pageSize,
                status: status,
                transactionType: type,
                user: id
            };
            try {
                setIsLoading(true);
                setLoaderDelay(false);
                const res = await userServices.getusertransaction(body);
                setTimeout(() => {
                    if (res.status === 200) {
                        setData(res?.data?.data?.data);
                        setTotalPages(res?.data?.data?.totalcount);
                    }
                    setLoaderDelay(true);
                }, 500);
            } catch (err) {
                setData(err?.response?.data?.message?.data);
                errorHandler(err);
                setLoaderDelay(false);
            } finally {
                setIsLoading(false);
                setLoaderDelay(false);
            }
        }
    };

    const debouncedSearch = useCallback(
        debounce((query) => fetchUsers(query), 400),
        [currentPage, pageSize, status , type]
    );

    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchItem(query);
        debouncedSearch(query);
    };

    const handlePageChange = (page) => setCurrentPage(page);

    const handleApprove = async (id, action) => {
        const actionText = action === "completed" ? "accept this transaction" : "reject this transaction";

        Swal.fire({
            text: `Are you sure you want to ${actionText}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#00a1da",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const payload = {
                        transactionId: id,
                        status: action,
                    };

                    const res = await userServices.ApproveRejectAmount(payload);
                    if (res.status === 200) {
                        toast.success(res?.data?.message, { toastId: "success" });
                        setRefresh((prev) => !prev);
                    } else {
                        toast.error(res?.data?.message, { toastId: "error" });
                    }
                } catch (err) {
                    errorHandler(err);
                }
            }
        });
    };

    const toggleChecked = async (id, currentStatus) => {
        console.log(currentStatus);
        try {
            const newStatus = currentStatus === 1 ? 0 : 1;
            const res = await userServices.changeStatus({
                id,
                status: newStatus,
            });

            if (res.status === 200) {
                toast.success(res?.data?.message, { toastId: "success" });
                setRefresh(!refresh);
            } else {
                toast.error(res?.data?.message, { toastId: "error" });
            }
        } catch (err) {
            errorHandler(err);
        }
    };

    useEffect(() => {
        fetchUsers(searchItem);
    }, [currentPage, pageSize, status, refresh, id , type]);

    const columns = [
        {
            name: "S.No.",
            cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
            width: "100px"
        },
        {
            name: "Transaction Id",
            sortable: true,
            selector: (row) => row.transactionId,
        },
        {
            name: "Sign Name",
            sortable: true,
            selector: (row) => capitalize(row?.signName),
        },

        {
            name: "Transaction Type",
            sortable: true,
            selector: (row) => capitalize(row.transactionType),
        },
        {
            name: "Transaction Date",
            sortable: true,
            selector: (row) => capitalize(fDate(row.createdAt)),
        },


        {
            name: "Accept/Reject",
            cell: (row) =>

                row.status === "pending" ? (
                    <>
                        <Button
                            variant="contained"
                            size="small"
                            className="btncolor"
                            onClick={() => handleApprove(row._id, "completed")}
                        >
                            Accept
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={() => handleApprove(row._id, "cancelled")}
                            sx={{ ml: 1 }}
                        >
                            Reject
                        </Button>
                    </>
                ) :
                    <Button
                        variant="contained"
                        color="success"
                        size="small"
                        disabled
                    >
                        {capitalize(row.status)}
                    </Button>,
        },

        {
            name: "Action",
            right: true,
            cell: (row) => (
                <>
                    <Tooltip title="View" placement="top">
                        <IconButton
                            color="primary"
                            onClick={() => {
                                setModalShow(true);
                                setViewId(row._id);
                            }}
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <Card>
            <CardHeader title="Transaction History" />
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                }}
            >
                <TableFilter
                    data={Verification_OPTIONS}
                    value={status}
                    setValue={setStatus}
                    filterName="Status"
                />

                <TableFilter
                    data={TRANGATIONTYPE_TYPE}
                    value={type}
                    setValue={setType}
                    filterName="Transaction Type"
                />


                <Input
                    value={searchItem}
                    placeholder="Search"
                    onChange={handleSearchChange}
                    sx={{ ml: 3, mr: 3 }}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="clear-search"
                                onClick={() => {
                                    setSearchItem("");
                                    fetchUsers("");
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </Box>
            <CardContent>
                <DataTable
                    customStyles={{
                        headCells: {
                            style: {
                                fontSize: "15px",
                                fontWeight: "bold",
                            },
                        },
                    }}
                    columns={columns}
                    data={data}
                    pagination
                    paginationServer
                    paginationTotalRows={totalPages}
                    onChangePage={handlePageChange}
                    paginationPerPage={pageSize}
                    paginationRowsPerPageOptions={[10, 20, 50]}
                    onChangeRowsPerPage={(currentRowsPerPage) =>
                        setPageSize(currentRowsPerPage)
                    }
                    progressPending={isLoading || !loaderDelay}
                    progressComponent={<Loader />}
                    className="custom"
                />
            </CardContent>
            
            <Dialog
                open={show}
                onClose={() => setShow(false)}
                className="popupbox-statis"
            >
                <DialogTitle>{warning}</DialogTitle>
                <DialogActions className="status-box-action">
                    <Button
                        variant="outlined"
                        onClick={() => {
                            toggleChecked(statusId, currentStatus);
                            setShow(false);
                        }}
                        color="primary"
                    >
                        Yes
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => setShow(false)}
                        color="primary"
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            {modalShow ? (
                <ViewTransactionDetail
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    id={viewId}
                />
            ) : (
                ""
            )}
        </Card>
    );
}